//资源管理(菜单)
const resource = {
  "add":"/sys/sysmng/resource/add",//新增
  "list":"/sys/sysmng/resource/find",//列表
  "modify":"/sys/sysmng/resource/modify",//修改资源
  "find":"/sys/sysmng/resource/select",//查找单个
  "delete":"/sys/sysmng/resource/delete"//删除
};

//角色管理
const role = { 
  "add":"/sys/rolemng/role/add",//新增
  "list":"/sys/rolemng/role/find",//列表
  "modify":"/sys/rolemng/role/modify",//修改资源
  "find":"/sys/rolemng/role/select",//查找单个
  "delete":"/sys/rolemng/role/delete"//删除
};

//用户角色
const userRole = {
  "add":"/sys/user/userrole/add",//新增
};
//角色资源
const roleRsc = {
  "auth":"/sys/rolemng/roleRsc/authorresource",//已授权
	"add":"/sys/rolemng/roleRsc/batchadd",//新增
	"delete":"/sys/rolemng/roleRsc/delete",//删除
	"list":"/sys/rolemng/roleRsc/find",//列表
	"modify":"/sys/rolemng/roleRsc/modify",//修改
	"find":"/sys/rolemng/roleRsc/select"//单个
}

//用户管理
const user = {
  "add":"/sys/user/add",//新增
  "list":"/sys/user/list",//列表
  "modify":"/sys/user/modify",//修改
  "find":"/sys/rolemng/role/select",//查找单个
  "delete":"/sys/rolemng/role/delete",//删除
  "resetpwd":"/sys/user/resetpwd"//重置密码
};
export {
  resource,
  role,
  roleRsc,
  user,
  userRole
}
